import React from "react";
import { Link } from "react-router-dom";
import "./Card.css";
import img1 from "../../assets/icons/custompackaging.png";
import img2 from "../../assets/icons/custompackaging.png";


const data = [
  {
    id: 1,
    image: img1,
    title: "Diabetic Care",
    link:"/service/alf",
  },
  {
    id: 2,
    image: img2,
    title: "Bath Safety",
    link:"/service/pharmacy",
  },
  {
    id: 3,
    image: img2,
    title: "Skin Care & Foot Care",
    link:"/service/pharmacy",
  },
  {
    id: 4,
    image: img2,
    title: "Ostomy",
    link:"/service/pharmacy",
  },
  {
    id: 5,
    image: img2,
    title: "Compression Stockings",
    link:"/service/pharmacy",
  },
  {
    id: 6,
    image: img2,
    title: "Incontinence",
    link:"/service/pharmacy",
  },
  {
    id: 7,
    image: img2,
    title: "Wound Care",
    link:"/service/pharmacy",
  },
  {
    id: 8,
    image: img2,
    title: "Pain Management",
    link:"/service/pharmacy",
  },
  {
    id: 9,
    image: img2,
    title: "Pediatrics",
    link:"/service/pharmacy",
  },
  {
    id: 10,
    image: img2,
    title: "Walking Accesories",
    link:"/service/pharmacy",
  },
  {
    id: 11,
    image: img2,
    title: "Daily Living Aid",
    link:"/service/pharmacy",
  },
];

const Card2 = () => {
  return (
    <div className="card-container">
      {data.map((item) => {
        return (
          <div className="card" key={item.id}>
            <h1 className="title">{item.title}</h1>
            <img className="card-image" src={item.image} alt={item.title} />
            <div className="text1">
              <div className="text-content">
                <Link className="body-btn" to={item.link}>
                    Read More
                  </Link>
              </div>
            </div>
            <svg
              className="chevron"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 100 35"
              width="30"
            >
              <path
                d="M5 30L50 5l45 25"
                fill="none"
                stroke="#000"
                stroke-width="5"
              />
            </svg>
          </div>
        );
      })}
    </div>
  );
};

export default Card2;
